export default __webpack_public_path__ + "static/media/Button-Auctions.0eb55cd5.svg";